import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface PayedTillResponse {
  payed_till: string;
}

export const getPayedTill = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('service-provider/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as PayedTillResponse;
};
